import preloader from './modules/loader-page';
import animate from './modules/index-animate';
import sidebar from './modules/sidebar';
import gallery from './modules/gallery';
import watchMoving from './modules/backgroundMoving';
import sharing from './modules/sharing';
import buttonDown from './modules/buttonDown';
import store from './store/index';

sharing();
buttonDown({
    el: '.button-down',
    scrollEl: '.footer'
});

function callback() {
    animate.start();
    sidebar({
        button: '.sidebar-btn',
        frame: '.wrapper',
        sidebar: '.o-sidebar',
        mobileWidth: store.MOBILE_WIDTH
    });
    gallery.open();
    
    watchMoving({
        el: '.scene',
        minWidth: store.MOBILE_WIDTH
    });
}

let loader = new preloader({
    element: '#loader-page',
    callback: callback
});


// WEBPACK FOOTER //
// ./index.js